import { render, staticRenderFns } from "./AssuranceBien.vue?vue&type=template&id=92161b80&"
import script from "./AssuranceBien.vue?vue&type=script&lang=js&"
export * from "./AssuranceBien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports